/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Modalita\' di mappatura del valore aggregato al punteggio
 */
export enum ModalitaMappa {

    SE_MATCH = 'SE_MATCH',

    PER_UNITA = 'PER_UNITA',

    PROPORZIONALE_AL_VALORE = 'PROPORZIONALE_AL_VALORE',

    A_FASCE = 'A_FASCE'
}

